import angular, { Injectable } from "angular";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../server/serverUtility";
import {
  FormViewService,
  FormViewServiceFormFactory,
  vsServiceName,
} from "./service";

export const vsProviderName = `${vsServiceName}Provider`;

export class FormViewServiceProvider implements angular.IServiceProvider {
  private readonly _configs: {
    [name: string]: Injectable<FormViewServiceFormFactory> | undefined;
  } = {};

  addFormViewConfig(
    name: string,
    config: Injectable<FormViewServiceFormFactory>
  ) {
    this._configs[name] = config;
  }

  $get: any = [
    ServerUtilityName,
    "$injector",
    (
      serverUtility: ServerUtility,
      $injector: angular.auto.IInjectorService
    ) => {
      return new FormViewService(this._configs, serverUtility, $injector);
    },
  ];
}
